export default "__VITE_PUBLIC_ASSET__a79b692f__"